<template>
  <div>
    <!-- PC端header -->
    <div :class="!isScroll_0 || whiteBg ? 'hHeader havaBg' : 'hHeader'">
    <!-- whiteBg -->
      <!-- 在线咨询 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :append-to-body='true'
        :show-close='false'
        :lock-scroll="false"
        width="380px"
        >
        <div class="diaBox">
          <div class="diaClose">
            <i class="el-icon-close" @click="dialogVisible = false"></i>
          </div>
          <div class="diaInner">
            <img class="diaCode" src="../../assets/images/code.png" alt="">
            <p>Code scanning consultation online customer service</p>
          </div>
        </div>
      </el-dialog>
      <!-- 导航栏左侧logo -->
      <img class="logo" :src="!isScroll_0 || whiteBg ? logo2  : logo1" alt="">
      <!-- 导航栏右侧文字 -->
      <div class="linkBox">
        <ul>
          <li>
            <a href="javascript:void(0);" @click="goHome">中文官网</a>
            <transition name="el-zoom-in-center">
              <div class="underline transition-box"></div>
            </transition>
          </li>
        </ul>
        <div class="consult animate__animated animate__pulse" @click="consultClick">
          <a href="javascript:void(0);" class="comButton collection-1 btn-15"><span><i class="el-icon-phone-outline"/>   Online consultation</span></a>
        </div>
      </div>
    </div>
    <!-- 移动端header -->
    <div class="mobileHeader" >
      <img class="mobile_logo" :src="logo2" alt="">
      <div class="mobile_hr">
        <img class="callBt" src="../../assets/images/mobile_01.png" alt="" @click="consultClick">
        <p @click="goHome">中文官网</p>
      </div>
    </div>
  </div>
</template>

<script>
// import { getlinks } from '@/service/servicePc'
export default {
  data () {
    return {
      pageTips: '',
      isScroll_0: true, // 判断滚轮是否到顶部
      logo1: require('../../assets/images/logo_01.png'), // logo白色
      logo2: require('../../assets/images/logo_02.png'), // logo蓝色
      list: [], // 一级导航数据
      dialogVisible: false, // 在线咨询开关
      whiteBg: false,
      thePath: Number,
      popupVisible: true
    }
  },
  methods: {
    // 监听滚轮
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      scrollTop === 0 ? this.isScroll_0 = true : this.isScroll_0 = false
    },
    // 点击在线咨询
    consultClick () {
      this.dialogVisible = true
    },
    // 导航 点击跳转
    toLink () {
      this.$router.push('/')
    },
    // 点击logo返回首页
    goHome () {
      this.$router.push('/')
    },
    // 导航栏 初始化
    initNav () {
      this.thePath = this.$route.path
      this.list.forEach(item => {
        item.isHover = false
        if (item.path === this.$route.path) {
          item.isHover = true
        }
      })
      console.log(this.list)
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.id) { this.pageTips = this.$route.query.id }
    // 监听滚轮
    window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {
    // 离开这个界面之后，删除滚动事件，不然容易除bug
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    $route: {
      handler (newVal, oldVal) {
        this.initNav()
        let url = window.location.href
        if (url.indexOf('newsInfo') !== -1 || url.indexOf('getPlan') !== -1) {
          this.whiteBg = true
        } else {
          this.whiteBg = false
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>

  // 移动端样式
@media only screen and (max-width: 1024px) {
  // el-dialog样式初始化
  /deep/ .el-dialog__body{
    padding: 0;
  }
  /deep/ .el-dialog__header{
    display: none;
  }
  .diaBox{
    background: url(https://a.perfma.net/fe/assets/4440563) no-repeat;
    background-size: cover;
    // 关闭按钮 X 样式
    .diaClose{
      height: 40px;
      text-align: right;
      font-size: 16px;
      padding: 12px;
      box-sizing: border-box;
      i{
        cursor: pointer;
      }
    }
    // 弹框内容样式
    .diaInner{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      padding: 20px 0;
      .diaLogo{
        width: 96px;
        height: 96px;
        margin-bottom: 24px;
      }
      .diaCode{
        width: 178px;
        height: 178px;
        margin-bottom: 16px;
      }
      p{
        width: 200px;
        text-align: center;
      }
    }
  }
  .hHeader{
    display: none;
  }
  .mobileHeader{
    width:100%;
    height: 2.75rem;
    padding: 0 1.375rem;
    box-sizing: border-box;
    box-shadow: 0px 2px 12px 0px rgba(204,204,204,0.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background: #fff;
    .mobile_logo{
      width: 5.5rem;
      height: 2rem;
    }
    .mobile_hr{
      display: flex;
      justify-content: center;
      align-items: center;
      .callBt{
        width: 5.6rem;
        height: 1.624rem;
        margin-right: 1.25rem;
      }
      .moreBt{
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .mobileHeader{
    display: none;
  }
  body{
    font-size:16px;
  }
  .comButton{
    color: #fff;
    border-radius: 0 28px 28px 28px;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg,#3EE3FF,#2E9EFD 41%,#186AE8);
    padding: 0;
    height:38px;
    font-size: 14px;
  }
  .btn-15:after{
    background-image: linear-gradient(315deg,#0027C2 0,#209DFF 74%);
  }
  // el-dialog样式初始化
  /deep/ .el-dialog__body{
    padding: 0;
  }
  /deep/ .el-dialog__header{
    display: none;
  }
  // 弹框样式
  .diaBox{
    background: url(https://a.perfma.net/fe/assets/4440563) no-repeat;
    background-size: cover;
    // 关闭按钮 X 样式
    .diaClose{
      height: 40px;
      text-align: right;
      font-size: 16px;
      padding: 12px;
      box-sizing: border-box;
      i{
        cursor: pointer;
      }
    }
    // 弹框内容样式
    .diaInner{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      padding: 20px 0;
      .diaLogo{
        width: 96px;
        height: 96px;
        margin-bottom: 24px;
      }
      .diaCode{
        width: 178px;
        height: 178px;
        margin-bottom: 16px;
      }
      p{
        width: 200px;
        text-align: center;
      }
    }
  }
  .hHeader{
    display: block;
    position: fixed;
    width: 100%;
    height: 64px;
    padding: 0 80px;
    box-sizing: border-box;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    top:0;
    // logo样式
    .logo{
      width: 137px;
      height: 50px;
      cursor: pointer;
    }
    .linkBox{
      display: flex;
      align-items: center;
      font-size: 16px;
      ul{
        display: flex;
        position: relative;
        li{
          position: relative;
          padding: 25px 20px;
          a{
            color: #fff;
          }
          // 加入我们二级菜单样式
          .joinBox{
            width: 170px;
            margin-left: -85px;
            li{
              strong{
                display: block;
                width: 100%;
                text-align: center !important;
              }
              strong:hover{
                cursor: pointer;
              }
            }
          }
        }
        .underline{
          position: absolute;
          bottom: 5px;
          left: 0;
          width: 100%;
          height: 3px;
          background: #428BF8;
          border-radius: 3px;
          transition: 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
        }
      }
      // 在线咨询样式
    }
  }
  // 导航栏变色样式
  .havaBg{
    background: #fff;
    .linkBox{
      ul{
        li{
          a{
            color: #353535;
          }
          a:hover{
            color: #346fff !important;
            cursor: pointer;
          }
          .haveColor{
            color: #346fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/header_English.vue